const createBusinessCategoryValidator =
  (validationError) => (value, businessCategoryValue, selectedOption) => {
    if (!value || (selectedOption && businessCategoryValue !== selectedOption.label))
      return validationError;

    return true;
  };

export default createBusinessCategoryValidator;
